"use client"

import * as React from "react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { StatusBadge } from "@/components/ui/status-badge"
import { Tip } from "@/components/ui/tip"
import { useQualityDashboardTerm } from "@/hooks/use-quality-dashboard-term"
import { termTimelineStatusMeta } from "@/lib/evaluation-term-utils"
import { cn } from "@/lib/utils"

export function QualityTermSelector() {
  const { termId, term, terms, setTermId } = useQualityDashboardTerm()
  const activeStatus = term ? termTimelineStatusMeta(term.timelinePosition) : null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={
            term
              ? `Academic term, ${term.termName}, ${activeStatus?.label ?? "Unknown status"}`
              : "Select academic term"
          }
          className={cn(
            "inline-flex items-center gap-1.5 rounded-full outline-none",
            "focus-visible:ring-2 focus-visible:ring-ring",
          )}
        >
          <StatusBadge
            label={term?.termName ?? "Select term"}
            tone={activeStatus?.tone ?? "neutral"}
            icon="fa-calendar-days"
            size="md"
          />
          <i className="fa-light fa-chevron-down text-xs text-muted-foreground" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuRadioGroup value={termId} onValueChange={setTermId}>
          {terms.map(item => {
            const status = termTimelineStatusMeta(item.timelinePosition)
            return (
              <DropdownMenuRadioItem
                key={item.id}
                value={item.id}
                className="flex items-center justify-between gap-3 pe-2"
              >
                <span className="min-w-0 truncate">{item.termName}</span>
                <StatusBadge
                  label={status.label}
                  tone={status.tone}
                  icon={status.icon}
                  size="md"
                />
              </DropdownMenuRadioItem>
            )
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
